import axiosInstance from "@/common/axiosInstance";

const apiCallStandard = async (method: 'get' | 'post', url: string, data?: any) => {
    try {
        const response = await axiosInstance[method]<any[]>(url, data);
        return response;
    } catch (err: any) {
        return {
            status: err?.status,
            message: err?.response?.data?.message || err?.message
        };
    }
};

export default apiCallStandard;